(function($) {
    $(() => {
        $('.match-h-jq').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h2-jq').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h3-jq').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h4-jq').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        objectFitImages();

        function matchHeight(selector) {
            const getDivs = document.querySelectorAll(selector);

            //Find out how my divs there are with the class 'match-height'
            const heights = [];

            //Create a loop that iterates through the getDivs variable and pushes the heights of the divs into an empty array
            for (let i = 0; i < getDivs.length; i++) {
                heights.push(getDivs[i].offsetHeight);
            }

            //Find the largest of the divs
            function getHighest() {
                return Math.max(...heights);
            }

            //Set a variable equal to the tallest div
            const tallest = getHighest();

            //Iterate through getDivs and set all their height style equal to the tallest variable
            for (let i = 0; i < getDivs.length; i++) {
                getDivs[i].style.height = tallest + "px";
            }
        }
        matchHeight('.match-h');
        matchHeight('.match-h2');
        matchHeight('.match-h3');
        matchHeight('.match-h4');
        matchHeight('.match-h5');
        $('.navbar-collapse').prepend(`
            <div class="mobile-menu-open">
                <i class="fal fa-times"></i>
            </div>
        `);

        $('.btn-back-wrapper').on('click', function () {
            window.history.back();
        });

        $('.back-btn').on('click', function () {
            window.history.back();
        });

        $('.js-parallax').jarallax({
            speed: 0.2,
            disableParallax: /iPad|iPhone|iPod|Android/
        });

        // MENU TRANSFORM ON SCROLLING
        const nav = $('#menu');
        $(window).scroll(function() {
            if($(window).scrollTop() > 120) {
                nav.addClass('scrolled');
            } else {
                nav.removeClass('scrolled');
            }
        });

        // Blog progress bar update
        // $(window).scroll(function() {
        //     // const headerHight = 80,
        //     // $('.readingProgressbarDot').css('left', `calc(${$(window).scrollTop()} / ${window.} * 100vw)`);
        //     document.styleSheets[0].addRule('.readingProgressbar:after',`left : calc(${$(window).scrollTop()} / 3916 * 100vw) !important`);
        //     // console.log($('.readingProgressbar::after'));
        // });
    });
})(jQuery);
